module.exports = __webpack_public_path__ + "static/media/44.f62c365d.JPG";